import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const baseUrl = process.env.REACT_APP_API_BASE_URL
interface UsersQueryParams {
  page?: number;
  rowsPerPage?: number;
  search?: string;
}
interface GovReportResponse {
  govId: number;
  count: number;
}
interface JobReportResponse {
  jobType: string;
  count: number;
}

const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (Headers: Headers, api) => {
      const token = localStorage.getItem("token");
      token && Headers.append("Authorization", "Bearer " + token);
    },
  }),

  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: (userData) => ({
        url: "Auth/Register",
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: userData,
      }),
    }),
    loginUser: builder.mutation({
      query: (userCredentials) => ({
        url: "Auth/Login",
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: userCredentials,
      }),
    }),
    forgotPassword: builder.mutation({
      query: (emailData: { email: string }) => ({
        url: "Auth/ForgotPassword",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: emailData,
      }),
    }),
    resetPassword: builder.mutation({
      query: (resetData: { token: string; newPassword: string }) => ({
        url: "Auth/ResetPassword",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: resetData,
      }),
    }),
    toggleUserStatus: builder.mutation({
      query: ({ userId, toggle }: { userId: string; toggle: boolean }) => ({
        url: `Auth/toggleUserStatus/${userId}/${toggle}`,
        method: "POST",
      }),
    }),

    getAllUsers: builder.query({
      query: ({
        page = 1,
        rowsPerPage = 10,
        search = "",
      }: UsersQueryParams = {}) => ({
        url: `Auth/get-all-users?page=${page}&pageSize=${rowsPerPage}&search=${encodeURIComponent(search)}`,
        method: "GET",
      }),
    }),
    getUsersByGov: builder.query<GovReportResponse[], void>({
      query: () => ({
        url: `Reports/UsersByGov`,
        method: "GET",
      }),
    }),
    getUsersByJob: builder.query<JobReportResponse[], void>({
      query: () => ({
        url: `Reports/UsersByJob`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useRegisterUserMutation,
  useLoginUserMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useToggleUserStatusMutation,
  useGetAllUsersQuery,
  useGetUsersByGovQuery,
  useGetUsersByJobQuery,
} = authApi;
export default authApi;
